export const LANDING_PAGE_URL = "https://wealthx.au";

export const VIDEO_BACKGROUND_URL =
  "https://d40salds722a6.cloudfront.net/vertical-landing-page.mp4";

export const INITIAL_APP_STATE = {
  isNotConnectingToAnyBank: false,
  isPullingBasiqData: false,
  shouldCreatePendingScenario: false,
  pendingToCreateScenario: [],
};

export const USER_STATE = {
  VERIFIED: "VERIFIED",
  CONTACTLESS: "CONTACTLESS",
};

export const AUTHENTICATED_REDIRECT_PAGES = [
  "login",
  "signup",
  "forgot-password",
  "logout",
  "recover-password",
];
export const NOT_DASHBOARD_ROUTES = [
  "login",
  "recover-password",
  "signup",
  "register",
  "forgot-password",
  "referral",
  "logout",
  "confirmation",
  "waiting-for-approval",
  "page-error",
  "404",
  "forbidden",
  "reset-2fa",
  "reset-2fa-request-sent",
];

export const USER_ROLE = {
  STAFF: "STAFF",
  USER: "USER",
  ADMIN: "ADMIN",
};
export const STAFF_ROLE = {
  BROKER: "BROKER",
  COMPANY_ADMIN: "COMPANY_ADMIN",
  SUPPORT: "SUPPORT",
};

export const CONFIRMATION_TYPE = {
  SHARE_DATA: "SHARE_DATA",
};

export const CONFIRMATION_STATUS = {
  PENDING: "PENDING",
};

export const COMPANY_STATUS = {
  APPROVED: "APPROVED",
  AWAITING_APPROVAL: "AWAITING_APPROVAL",
  REJECTED: "REJECTED",
  PAYMENT_OVERDUE: "PAYMENT_OVERDUE",
  DEACTIVATED: "DEACTIVATED",
};

export const DEFAULT_BROKER_DETAILS = {
  phoneNumber: "0416338438",
  supportEmail: "clint@wealthx.au",
  companyName: "WEALTHX",
  companyNumber: "27 608 729 942",
  creditRepNumber: "48720",
};

export const BUSINESS_TYPE = {
  BROKER: "MORTGAGE_BROKER",
  PLANNER: "FINANCIAL_PLANNER",
  ACCOUNTANT: "ACCOUNTANT",
};

export const USER_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING: "PENDING",
};

export const USER_BANK_CONNECTION_STATUS = {
  CONNECTED: "CONNECTED",
  NOT_CONNECTED: "NOT_CONNECTED",
  PENDING: "PENDING",
};

export const USER_ASSET_CONNECTED_STATUS = {
  CONNECTED: true,
  NOT_CONNECTED: false,
};

export const QUERY_CACHE_TIME = {
  DEFAULT: 30 * 60 * 1000,
};

export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

export const SIGNUP_STEPS = {
  PERSONAL_DETAILS: "Personal Details",
  CARD: "Payment",
  COMPANY: "Company Details",
  BRANDING: "Branding",
  SUCCESS: "Success",
};

export const DEFAULT_SIGNUP_STEPS = [
  SIGNUP_STEPS.PERSONAL_DETAILS,
  SIGNUP_STEPS.CARD,
  SIGNUP_STEPS.COMPANY,
  SIGNUP_STEPS.BRANDING,
  SIGNUP_STEPS.SUCCESS,
];

export const FREE_PLAN_SIGNUP_STEPS = [
  SIGNUP_STEPS.PERSONAL_DETAILS,
  SIGNUP_STEPS.COMPANY,
  SIGNUP_STEPS.BRANDING,
  SIGNUP_STEPS.SUCCESS,
];

export const BILLING_PLAN = {
  PADUA: "padua",
  ONBOARD: "onboard",
  STARTER: "starter",
  LAUNCH: "launch",
  ENTERPRISE: "enterprise",
};

export const SENDING_STATUS = {
  ENABLED: "ENABLED",
  DISABLED: "DISABLED",
  REINSTATED: "REINSTATED",
};
